import enviro from 'enviro';
import { Suspense, createContext, lazy, useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'quartz-routing/react-router';
import { AWARD_OVERLAY_URL_FRAGMENT, AWARD_URL_FRAGMENT, LEGACY_AWARD_OVERLAY_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT } from '../../../routes/academyRoutePaths';
import ErrorBoundary from '../../../components/error/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackAwardModal = /*#__PURE__*/lazy(() => import('./TrackAwardModal'));
const AwardModalContext = /*#__PURE__*/createContext(enviro.isProd() ? () => {} : () => {
  throw new Error('useOpenAwardModal must be used within an AwardModalProvider');
});
const AWARD_PATHS = [LEGACY_AWARD_OVERLAY_URL_FRAGMENT, AWARD_OVERLAY_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT, AWARD_URL_FRAGMENT];
function useAwardRouteDetection(openModal) {
  const match = useRouteMatch(AWARD_PATHS);
  const history = useHistory();
  useEffect(() => {
    if (!match) return;
    const id = Number(match.params.trackId);
    if (isNaN(id)) return;
    openModal(id);
    const prefix = match.url.replace(/\/award\/\d+.*$/, '');
    history.replace(prefix || '/');
  }, [match, history, openModal]);
}
export function AwardModalProvider({
  children
}) {
  const [trackId, setTrackId] = useState(null);
  const openModal = useCallback(id => setTrackId(id), []);
  const handleClose = useCallback(() => setTrackId(null), []);
  useAwardRouteDetection(openModal);
  return /*#__PURE__*/_jsxs(AwardModalContext.Provider, {
    value: openModal,
    children: [children, /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "AwardModalProvider",
      fallback: null,
      children: trackId !== null && /*#__PURE__*/_jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/_jsx(TrackAwardModal, {
          onClose: handleClose,
          trackId: trackId
        })
      })
    })]
  });
}
export const useOpenAwardModal = () => useContext(AwardModalContext);